import Alpine from "alpinejs";

interface MainMenu {
	open: boolean;
	toggle: CallableFunction;
	handleOpen: CallableFunction;
	handleClose: CallableFunction;
	handleEscape: CallableFunction;
}

const menu = (): MainMenu => {
	return {
		open: false,

		toggle() {
			this.open ? this.handleClose() : this.handleOpen();
		},

		handleOpen() {
			this.open = true;
			Alpine.store("docOverflow").updateCount(1);
		},

		handleClose() {
			this.open = false;
			Alpine.store("docOverflow").updateCount(-1);
		},

		handleEscape() {
			this.handleClose();
		},
	};
};

Alpine.data("menu", menu);
